import {Modal} from 'antd';
import Countdown from "antd/es/statistic/Countdown";
import React, {useEffect} from 'react';
import gb1 from "../../../assets/images/modal-icon-instant-reward-1GB.png";
import gb4 from "../../../assets/images/modal-icon-instant-reward-4GB.png";
import {RewardDescription} from "../../../core/models/enums/rewardDescription";
import FirebaseService from "../../../core/services/firebaseService/firebase.service";
import {UI} from '../../../core/utilities/ui';
import './InstantRewardModal.scss';

interface IProps {
  rewardDescription: RewardDescription;
  callback: () => void;
}

const InstantRewardModal = (props: IProps) => {
  
  useEffect(() => {
    switch (props.rewardDescription) {
      case RewardDescription.instantWoHump:
        FirebaseService.logEvent(FirebaseService.user_count_1gb_surewin);
        break;
      case RewardDescription.instantWHump:
        FirebaseService.logEvent(FirebaseService.user_count_4gb_surewin);
        break;
    }
  }, [props.rewardDescription]);
  
  const getSrcIcon = () => {
    switch (props.rewardDescription) {
      case RewardDescription.instantWoHump:
        return gb1;
      case RewardDescription.instantWHump:
        return gb4;
    }
  }
  
  const handleFinishCountdown = (): void => {
    props.callback();
  }
  
  return (
    <Modal
      className="instant-reward-modal"
      maskStyle={UI.modalMaskStyle()}
      visible
      closable={false}
      footer={false}
      centered
      destroyOnClose
    >
      <div className="content">
        <img className="icon" src={getSrcIcon()} alt="instant-reward"/>
        <span className="title">Cüzdanına yüklendi!</span>
        <span className="text">Oyun sonucunu görmek için yönlendiriliyorsun.</span>
        <Countdown
          className="countdown"
          format="s"
          value={Date.now() + 6 * 1000}
          onFinish={handleFinishCountdown}
        />
      </div>
    </Modal>
  );
};

export default InstantRewardModal;
